import { createRoot } from 'react-dom/client';
import BasketWidget from 'src/widgets/activities/basket/BasketWidget';
import BilberryCustomElement from 'src/widgets/BilberryCustomElement';
import { WidgetWrapper } from 'src/widgets/WidgetWrapper';

class BilberryBasket extends BilberryCustomElement {
    protected renderWidget(): void {
        createRoot(this._mountPoint).render(
            <WidgetWrapper
                mountPoint={this._mountPoint}
                popoverMountPoint={this._popoverMountPoint}
                shadowRoot={this._shadowRoot}
            >
                <BasketWidget />
            </WidgetWrapper>,
        );
    }
}

export default function defineCustomElement(): void {
    customElements.define('bilberry-basket', BilberryBasket);
}
